module.exports = __webpack_public_path__ + "img/94.993c817f.svg";